import { ToastrManager } from 'ng6-toastr-notifications';
import { Component, Injector, OnInit } from '@angular/core';
import { BaseListComponent } from 'src/app/shared/components/base-list-component/base-list-component';
import { Order } from './order.model';
import { OrderService } from './orders.service';

@Component({
  selector: 'ng-orders',
  templateUrl: 'orders.component.html'
})

export class OrdersComponent extends BaseListComponent<Order>{


  constructor(
    public ordersServ:OrderService,
    public injector:Injector,
    public toastr:ToastrManager
  ){
    super(ordersServ, injector, 'order', {editUrl:'/admin/orders/edit', createUrl:'/admin/orders/new',detailUrl:'/admin/orders/detail'});

  }

  protected tableProprieties(): string[] {

    const columns= [
      'código',
      'Sócio',
      'Clube',
      'Total',
      'Criado em',
      'Processado em',
      'Enviado em',
      'Recebido em',
      'Estado'
    ];

    if(!this.isAdminOrUserKhuzela()) {
      columns.splice(2,1)
    }

    return columns;
  }

  protected initChildMethods(): void {}
  protected initChildProprieties(): void {}

}
